import type { JsonSchemaNode } from "@nmblr-platform-flow/schema";
import { humanize } from "../../../lib/humanize.js";

interface Props {
	name: string;
	schema: JsonSchemaNode;
	value: unknown;
	onChange: (value: unknown) => void;
	required?: boolean;
}

export function StringInput({ name, schema, value, onChange, required }: Props) {
	const id = `field-${name}`;
	const placeholder = schema["x-forge-placeholder"] ?? undefined;
	return (
		<label className="mb-3 block" htmlFor={id}>
			<span className="text-xs text-text-muted">
				{humanize(name)}
				{required && <span className="ml-1 text-error">*</span>}
			</span>
			<input
				id={id}
				type="text"
				value={typeof value === "string" ? value : ((schema.default as string | undefined) ?? "")}
				onChange={(e) => onChange(e.target.value)}
				placeholder={placeholder}
				className="mt-1 block w-full rounded-xl border border-border bg-canvas px-3 py-2 text-xs text-text-primary focus:border-accent focus:ring-1 focus:ring-accent focus:outline-none"
			/>
			{schema.description && (
				<span className="mt-1 block text-xs text-text-muted">{schema.description}</span>
			)}
		</label>
	);
}
